import cx from 'classnames'
import { FC } from 'react'
import HazShield from '../../assets/images/haz-shield.svg'
import { IoStar } from 'react-icons/io5'
import { colors, RPUser } from '@hazadapt-git/public-core-base'
import { isUserAdmin, isUserOwner } from '../../lib/utils'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { makeStyles } from 'tss-react/mui'

interface BaseProps {
    iconClassName?: string
    labelClassName?: string
    showType?: boolean
}

export const OwnerIcon: FC<BaseProps> = ({
    iconClassName,
    labelClassName,
    showType = false,
}) => {
    const { classes } = useLocalStyles()
    return (
        <Box
            display={showType ? 'grid' : 'flex'}
            gridTemplateColumns="1.375rem auto"
            flexDirection="row"
            gap="0.5rem"
            alignItems="center"
        >
            <img
                src={HazShield}
                alt="Navy shield with a white HazAdapt H inside"
                className={cx(classes.shield, iconClassName)}
            />
            {showType ? (
                <Typography component="span" className={labelClassName}>
                    Owner
                </Typography>
            ) : null}
        </Box>
    )
}

export const AdminIcon: FC<BaseProps> = ({
    iconClassName,
    labelClassName,
    showType = false,
}) => (
    <Box
        display={showType ? 'grid' : 'flex'}
        gridTemplateColumns={showType ? '1.375rem auto' : undefined}
        flexDirection="row"
        gap="0.5rem"
        alignItems="center"
    >
        <IoStar
            color={colors.primary.CERULEAN}
            className={iconClassName}
            size="1.25rem"
        />
        {showType ? (
            <Typography component="span" className={labelClassName}>
                Administrator
            </Typography>
        ) : null}
    </Box>
)

interface TeamMemberTypeIconProps extends BaseProps {
    user: RPUser
}

export const TeamMemberTypeIcon: FC<TeamMemberTypeIconProps> = ({
    user,
    iconClassName,
    labelClassName,
    showType = false,
}) => {
    if (isUserOwner(user))
        return (
            <OwnerIcon
                iconClassName={iconClassName}
                labelClassName={labelClassName}
                showType={showType}
            />
        )
    if (isUserAdmin(user))
        return (
            <AdminIcon
                iconClassName={iconClassName}
                labelClassName={labelClassName}
                showType={showType}
            />
        )
    return null
}

const useLocalStyles = makeStyles()({
    shield: {
        width: '1.375rem',
        height: '1.375rem',
        objectFit: 'contain',
        objectPosition: 'center',
    },
})
